import { useModuleData } from '@rebuild/hooks/data/useModuleData';

export const useQuestionDetailData = () => {
	const { question_detail } = useModuleData();

	const fetchQuestionDetail = async routeQuery => {
		const { uniqueCode, sourceBiz } = routeQuery || {};
		if (!uniqueCode || !sourceBiz) return null;

		await question_detail.refresh({
			uniqueCode,
			sourceBiz
		});

		return question_detail.data?.data?.[0] || null;
	};

	return {
		questionDetailModule: question_detail,
		fetchQuestionDetail
	};
};
